/** VELUNE – avis clients : filtre par produit, note minimale, tri, ordre aléatoire, plafond, carrousel et « voir plus ». */
if (!customElements.get('vl-reviews')) customElements.define(
  'vl-reviews',
  class extends HTMLElement {
    connectedCallback() {
      this.grid = this.querySelector('.vl-rv__grid');
      this.more = this.querySelector('.vl-rv__more');
      this.sort = this.querySelector('[data-sort]');
      if (this.sort?.querySelector('option[value="rating"]')) this.sort.value = 'rating';
      this.nav = this.querySelector('.vl-rv__nav');
      if (!this.grid) return;
      const min = Number(this.dataset.minRating) || 0;
      this.cards = [...this.grid.children].filter((card) => {
        const keep = Number(card.dataset.rating) >= min;
        if (!keep) card.remove();
        return keep;
      });
      this.random = this.hasAttribute('data-random');
      if (this.random) {
        for (let i = this.cards.length - 1; i > 0; i--) {
          const j = Math.floor(Math.random() * (i + 1));
          [this.cards[i], this.cards[j]] = [this.cards[j], this.cards[i]];
        }
      }
      this.max = Number(this.dataset.max) || Infinity;
      this.step = Number(this.dataset.perPage) || 6;
      this.limit = this.step;
      this.filter = '';
      this.addEventListener('click', this.#onClick);
      this.sort?.addEventListener('change', this.#render);
      this.resizeObserver = new ResizeObserver(() => this.#updateNav());
      this.resizeObserver.observe(this.grid);
      this.#render();
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.#onClick);
      this.sort?.removeEventListener('change', this.#render);
      this.resizeObserver?.disconnect();
    }

    #onClick = (event) => {
      const target = event.target instanceof Element ? event.target : null;
      const arrow = target?.closest('[data-dir]');
      const chip = target?.closest('[data-filter]');
      if (arrow) {
        const card = this.cards.find((c) => !c.hidden);
        const gap = parseFloat(getComputedStyle(this.grid).columnGap) || 0;
        const step = card ? card.getBoundingClientRect().width + gap : this.grid.clientWidth;
        this.grid.scrollBy({ left: step * Number(arrow.dataset.dir), behavior: 'smooth' });
      } else if (chip) {
        this.filter = chip.dataset.filter;
        this.limit = this.step;
        this.querySelectorAll('[data-filter]').forEach((c) => c.setAttribute('aria-pressed', String(c === chip)));
        this.#render();
      } else if (target?.closest('.vl-rv__more')) {
        this.limit += this.step;
        this.#render();
      }
    };

    #updateNav = () => {
      if (this.nav) this.nav.hidden = this.grid.scrollWidth <= this.grid.clientWidth + 1;
    };

    #render = () => {
      const mode = this.sort?.value || 'date';
      const byDate = (a, b) => (b.dataset.date || '').localeCompare(a.dataset.date || '');
      const sorted = this.random && !this.sort ? [...this.cards] : [...this.cards].sort((a, b) => {
        const ra = Number(a.dataset.rating);
        const rb = Number(b.dataset.rating);
        if (mode === 'rating') return rb - ra || byDate(a, b);
        if (mode === 'rating_low') return ra - rb || byDate(a, b);
        return byDate(a, b);
      });
      const cap = this.classList.contains('vl-rv--carousel') ? this.max : Math.min(this.limit, this.max);
      let shown = 0;
      let matching = 0;
      sorted.forEach((card) => {
        const match = !this.filter || card.dataset.product === this.filter;
        if (match) matching++;
        const visible = match && shown < cap;
        if (visible) shown++;
        card.hidden = !visible;
        this.grid.append(card);
      });
      if (this.more) this.more.hidden = matching <= shown || shown >= this.max;
      this.grid.scrollLeft = 0;
      this.#updateNav();
    };
  }
);
